// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.model-tab-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.model-tab-header {
  display: flex;
  gap: var(--input-element-gap);
  align-items: center;
  margin-bottom: var(--input-element-gap);
  justify-content: right;
}

.model-tab-header button {
  box-shadow: 0 0 5px -2px var(--border-color);
  border-radius: 5px;
}

.model-tab-header input {
  flex: 1;
}

.model-tab-checkbox {
  display: flex;
  align-items: center;
  gap: 4px;
}

.model-tab-body {
  display: flex;
  height: 100%;
  min-height: 0;
}

.model-tree {
  flex: 1;
  overflow: auto;
  padding: 4px;
  font-size: 13px;
  min-height: 0;
}

.model-properties {
  display: flex;
  flex-direction: column;
  flex: 2;
  border-left: 1px solid #ccc;
  padding: 8px;
  overflow: hidden;
  min-height: 0;
}

.model-node {
  cursor: pointer;
  user-select: none;
  padding: 2px 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.model-node:hover {
  background-color: rgba(5, 50, 110, 0.5);
  color: white;
  background-blend-mode: multiply;
}

.model-node-arrow {
  width: 12px;
}

.model-node-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

/* change colors */

.model-node.created {
  color: #2ecc71; /* green */
}

.model-node.updated {
  color: #9b59b6; /* purple */
}

.model-node.deleted {
  color: #e74c3c; /* red */
  text-decoration: line-through;
}

.model-node.selected {
  background: rgba(0, 120, 255, 0.15);
}

.model-properties-heading {
  margin-top: 0;
  border-bottom: 1px solid #181818
}

.model-properties-content {
  overflow: auto;
}

.model-properties-heading.collapsible {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 5px;
}

.collapse-arrow {
  font-size: 12px;
  transition: transform 0.2s ease;
}

.collapse-arrow.collapsed {
  transform: rotate(-90deg); /* points right */
}

/* Facet view */

.facet-properties-entry {
  font-size: var(--font-size-s);
}

.facet-properties-entry .facet-name {
  font-weight: bold;
  margin-left: 10px;
  margin-right: 20px;
  margin-top: 10px;
  margin-bottom: 5px;
  border-bottom: 1px solid var(--border-color);
}

.facet-properties-entry:first-child .facet-name {
  margin-top: 0px;
}

.facet-properties-entry .facet-properties > table {
  border-left: none;
}

.facet-properties-empty {
  padding-left: 16px;
  font-style: italic;
  opacity: 0.7;
}

/* Property table */

.model-properties-table {
  border-collapse: collapse;
  font-size: var(--font-size-s);
  width: 100%;
}

.model-properties-table td {
  padding: 1px var(--input-element-gap-small);
  vertical-align: top;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.model-properties-key {
  font-weight: bold;
  white-space: nowrap;
  padding-right: var(--input-element-gap);
  text-transform: capitalize;
}

.model-properties-value {
  overflow-x: auto
}

.model-subtable {
  border-collapse: collapse;
  border-left: 1px solid #444;
  display: table;
  margin-left: 8px;
  width: calc(100% - 16px);
}

.model-subtable td {
  padding: 1px var(--input-element-gap-small);
  vertical-align: top;
}

.model-subtable-key {
  font-weight: bold;
  white-space: nowrap;
  padding-right: var(--input-element-gap);
  vertical-align: top;
  text-transform: capitalize;
}

.model-subtable-value {
  width: 100%;
  white-space: nowrap;
}

.facet-number-matrix {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.facet-color-field {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.facet-color-swatch {
  width: 1.2em;
  height: 1.2em;
  min-width: unset;
  border-radius: 4px;
  padding: 0;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.35);
}

.facet-color-native-input {
  position: absolute;
  pointer-events: none;
  opacity: 0;
  width: 0;
  height: 0;
}

.facet-color-hex-input {
  flex: 1 1 auto;
  min-width: 0;
  font-size: var(--font-size-s);
  line-height: 1.2;
  border-radius: 3px;
  padding: 5px;
  height: unset;
}

.facet-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  height: unset;
  width: 48px;
  padding: 0;
  border: none;
  background: transparent;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  box-shadow: none;
  cursor: pointer;
}

.facet-toggle:hover,
.facet-toggle:focus,
.facet-toggle:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: none;
}

.facet-toggle-track {
  position: relative;
  width: 48px;
  height: 1em;
  border-radius: 999px;
  background: #666;
  transition: background-color 0.18s ease;
}

.facet-toggle-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: calc(1em - 6px);
  height: calc(1em - 6px);
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.35);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.facet-toggle.is-on .facet-toggle-track {
  background: #1f8f4d;
}

.facet-toggle.is-on .facet-toggle-thumb {
  transform: translateX(28px);
}

.facet-toggle:hover .facet-toggle-thumb,
.facet-toggle:focus-visible .facet-toggle-thumb {
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.2), 0 1px 4px rgba(0, 0, 0, 0.35);
}

.facet-number-input,
.facet-enum-select {
  min-width: 0;
  font-size: var(--font-size-s);
  line-height: 1.2;
}

.facet-number-input {
  width: 100%;
  flex: 1 1 0;
  height: unset;
  border-radius: 3px;
  padding: 5px;
}

.facet-enum-select {
  height: unset;
  padding: 1px 2px;
  border-radius: 3px;
}

.facet-number-tuple {
  display: flex;
  gap: 6px;
  width: 100%;
}

.facet-number-tuple .facet-number-input {
  flex: 1 1 0;
  width: 100%;
  height: unset;
  border-radius: 3px;
  padding: 5px;
}

.safe-value-picker {
  position: relative;
  display: flex;
  align-items: stretch;
  width: 100%;
  min-width: 0;
  gap: 6px;
}

.safe-value-picker__field {
  position: relative;
  flex: 1;
  min-width: 0;
}

.safe-value-picker__current {
  min-width: 0;
}

.safe-value-picker__current--hidden {
  visibility: hidden;
}

.safe-value-picker__undefined {
  display: flex;
  align-items: center;
  min-height: 32px;
}

.safe-value-picker__panel {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  min-height: 100%;
  overflow: visible;
  border: 1px solid #4d4d4d;
  border-radius: 3px;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.35);
}

.safe-value-picker__toggle {
  flex: 0 0 auto;
  min-width: 32px;
  padding-inline: 8px;
}

.safe-value-picker__option {
  display: block;
  width: 100%;
  padding: 8px 10px;
  border: none;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.safe-value-picker__option:hover {
  background: rgba(0, 0, 0, 0.06);
  border-radius: 3px;
}

.safe-value-picker__option-preview {
  pointer-events: none;
}

.matrix-element {
  text-align: right;
}

.model-properties-empty {
  font-style: italic;
  opacity: 0.7;
}

.model-tab-context-menu {
  position: fixed;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  min-width: 170px;
  padding: 4px;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.35);
}

.model-tab-context-menu button {
  border: none;
  border-radius: 4px;
  background: transparent;
  color: inherit;
  text-align: left;
  padding: 8px 10px;
  cursor: pointer;
}

.model-tab-context-menu button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 1);
}

.model-tab-context-menu button:disabled {
  cursor: default;
  opacity: 0.5;
}

.property-created {
  color: #2ecc71 !important;
  font-weight: 500 !important;
  background: rgba(155, 89, 182, 0.12) !important;
}

.property-updated {
  color: #9b59b6 !important;
  font-weight: 500 !important;
  background: rgba(155, 89, 182, 0.12) !important;
}

.property-deleted {
  color: #e74c3c !important;
  font-weight: 500 !important;
  background: rgba(155, 89, 182, 0.12) !important;
}

/* Model filtering */

.model-node-highlight {
  background-color: yellow;
  color: black;
  font-weight: bold;
}

.model-node-uid {
  color: #888;
  font-size: 0.85em;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/debug-overlay/model-tab/ModelTab.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,OAAO;EACP,cAAc;EACd,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,kBAAkB;;AAElB;EACE,cAAc,EAAE,UAAU;AAC5B;;AAEA;EACE,cAAc,EAAE,WAAW;AAC7B;;AAEA;EACE,cAAc,EAAE,QAAQ;EACxB,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA,eAAe;;AAEf;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA,mBAAmB;;AAEnB;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,WAAW;EACX,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,6EAA6E;AAC/E;;AAEA;;EAEE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,oBAAoB;;AAEpB;EACE,wBAAwB;EACxB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB","sourcesContent":[".model-tab-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n\n.model-tab-header {\n  display: flex;\n  gap: var(--input-element-gap);\n  align-items: center;\n  margin-bottom: var(--input-element-gap);\n  justify-content: right;\n}\n\n.model-tab-header button {\n  box-shadow: 0 0 5px -2px var(--border-color);\n  border-radius: 5px;\n}\n\n.model-tab-header input {\n  flex: 1;\n}\n\n.model-tab-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.model-tab-body {\n  display: flex;\n  height: 100%;\n  min-height: 0;\n}\n\n.model-tree {\n  flex: 1;\n  overflow: auto;\n  padding: 4px;\n  font-size: 13px;\n  min-height: 0;\n}\n\n.model-properties {\n  display: flex;\n  flex-direction: column;\n  flex: 2;\n  border-left: 1px solid #ccc;\n  padding: 8px;\n  overflow: hidden;\n  min-height: 0;\n}\n\n.model-node {\n  cursor: pointer;\n  user-select: none;\n  padding: 2px 4px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.model-node:hover {\n  background-color: rgba(5, 50, 110, 0.5);\n  color: white;\n  background-blend-mode: multiply;\n}\n\n.model-node-arrow {\n  width: 12px;\n}\n\n.model-node-name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n/* change colors */\n\n.model-node.created {\n  color: #2ecc71; /* green */\n}\n\n.model-node.updated {\n  color: #9b59b6; /* purple */\n}\n\n.model-node.deleted {\n  color: #e74c3c; /* red */\n  text-decoration: line-through;\n}\n\n.model-node.selected {\n  background: rgba(0, 120, 255, 0.15);\n}\n\n.model-properties-heading {\n  margin-top: 0;\n  border-bottom: 1px solid #181818\n}\n\n.model-properties-content {\n  overflow: auto;\n}\n\n.model-properties-heading.collapsible {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  gap: 5px;\n}\n\n.collapse-arrow {\n  font-size: 12px;\n  transition: transform 0.2s ease;\n}\n\n.collapse-arrow.collapsed {\n  transform: rotate(-90deg); /* points right */\n}\n\n/* Facet view */\n\n.facet-properties-entry {\n  font-size: var(--font-size-s);\n}\n\n.facet-properties-entry .facet-name {\n  font-weight: bold;\n  margin-left: 10px;\n  margin-right: 20px;\n  margin-top: 10px;\n  margin-bottom: 5px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.facet-properties-entry:first-child .facet-name {\n  margin-top: 0px;\n}\n\n.facet-properties-entry .facet-properties > table {\n  border-left: none;\n}\n\n.facet-properties-empty {\n  padding-left: 16px;\n  font-style: italic;\n  opacity: 0.7;\n}\n\n/* Property table */\n\n.model-properties-table {\n  border-collapse: collapse;\n  font-size: var(--font-size-s);\n  width: 100%;\n}\n\n.model-properties-table td {\n  padding: 1px var(--input-element-gap-small);\n  vertical-align: top;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.model-properties-key {\n  font-weight: bold;\n  white-space: nowrap;\n  padding-right: var(--input-element-gap);\n  text-transform: capitalize;\n}\n\n.model-properties-value {\n  overflow-x: auto\n}\n\n.model-subtable {\n  border-collapse: collapse;\n  border-left: 1px solid #444;\n  display: table;\n  margin-left: 8px;\n  width: calc(100% - 16px);\n}\n\n.model-subtable td {\n  padding: 1px var(--input-element-gap-small);\n  vertical-align: top;\n}\n\n.model-subtable-key {\n  font-weight: bold;\n  white-space: nowrap;\n  padding-right: var(--input-element-gap);\n  vertical-align: top;\n  text-transform: capitalize;\n}\n\n.model-subtable-value {\n  width: 100%;\n  white-space: nowrap;\n}\n\n.facet-number-matrix {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.facet-color-field {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.facet-color-swatch {\n  width: 1.2em;\n  height: 1.2em;\n  min-width: unset;\n  border-radius: 4px;\n  padding: 0;\n  cursor: pointer;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.35);\n}\n\n.facet-color-native-input {\n  position: absolute;\n  pointer-events: none;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.facet-color-hex-input {\n  flex: 1 1 auto;\n  min-width: 0;\n  font-size: var(--font-size-s);\n  line-height: 1.2;\n  border-radius: 3px;\n  padding: 5px;\n  height: unset;\n}\n\n.facet-toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-start;\n  height: unset;\n  width: 48px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  appearance: none;\n  -webkit-appearance: none;\n  outline: none;\n  box-shadow: none;\n  cursor: pointer;\n}\n\n.facet-toggle:hover,\n.facet-toggle:focus,\n.facet-toggle:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: none;\n}\n\n.facet-toggle-track {\n  position: relative;\n  width: 48px;\n  height: 1em;\n  border-radius: 999px;\n  background: #666;\n  transition: background-color 0.18s ease;\n}\n\n.facet-toggle-thumb {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: calc(1em - 6px);\n  height: calc(1em - 6px);\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.35);\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\n}\n\n.facet-toggle.is-on .facet-toggle-track {\n  background: #1f8f4d;\n}\n\n.facet-toggle.is-on .facet-toggle-thumb {\n  transform: translateX(28px);\n}\n\n.facet-toggle:hover .facet-toggle-thumb,\n.facet-toggle:focus-visible .facet-toggle-thumb {\n  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.2), 0 1px 4px rgba(0, 0, 0, 0.35);\n}\n\n.facet-number-input,\n.facet-enum-select {\n  min-width: 0;\n  font-size: var(--font-size-s);\n  line-height: 1.2;\n}\n\n.facet-number-input {\n  width: 100%;\n  flex: 1 1 0;\n  height: unset;\n  border-radius: 3px;\n  padding: 5px;\n}\n\n.facet-enum-select {\n  height: unset;\n  padding: 1px 2px;\n  border-radius: 3px;\n}\n\n.facet-number-tuple {\n  display: flex;\n  gap: 6px;\n  width: 100%;\n}\n\n.facet-number-tuple .facet-number-input {\n  flex: 1 1 0;\n  width: 100%;\n  height: unset;\n  border-radius: 3px;\n  padding: 5px;\n}\n\n.safe-value-picker {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  min-width: 0;\n  gap: 6px;\n}\n\n.safe-value-picker__field {\n  position: relative;\n  flex: 1;\n  min-width: 0;\n}\n\n.safe-value-picker__current {\n  min-width: 0;\n}\n\n.safe-value-picker__current--hidden {\n  visibility: hidden;\n}\n\n.safe-value-picker__undefined {\n  display: flex;\n  align-items: center;\n  min-height: 32px;\n}\n\n.safe-value-picker__panel {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1;\n  min-height: 100%;\n  overflow: visible;\n  border: 1px solid #4d4d4d;\n  border-radius: 3px;\n  background: #ffffff;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.35);\n}\n\n.safe-value-picker__toggle {\n  flex: 0 0 auto;\n  min-width: 32px;\n  padding-inline: 8px;\n}\n\n.safe-value-picker__option {\n  display: block;\n  width: 100%;\n  padding: 8px 10px;\n  border: none;\n  background: transparent;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.safe-value-picker__option:hover {\n  background: rgba(0, 0, 0, 0.06);\n  border-radius: 3px;\n}\n\n.safe-value-picker__option-preview {\n  pointer-events: none;\n}\n\n.matrix-element {\n  text-align: right;\n}\n\n.model-properties-empty {\n  font-style: italic;\n  opacity: 0.7;\n}\n\n.model-tab-context-menu {\n  position: fixed;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  min-width: 170px;\n  padding: 4px;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.5);\n  backdrop-filter: blur(10px);\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.35);\n}\n\n.model-tab-context-menu button {\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color: inherit;\n  text-align: left;\n  padding: 8px 10px;\n  cursor: pointer;\n}\n\n.model-tab-context-menu button:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 1);\n}\n\n.model-tab-context-menu button:disabled {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.property-created {\n  color: #2ecc71 !important;\n  font-weight: 500 !important;\n  background: rgba(155, 89, 182, 0.12) !important;\n}\n\n.property-updated {\n  color: #9b59b6 !important;\n  font-weight: 500 !important;\n  background: rgba(155, 89, 182, 0.12) !important;\n}\n\n.property-deleted {\n  color: #e74c3c !important;\n  font-weight: 500 !important;\n  background: rgba(155, 89, 182, 0.12) !important;\n}\n\n/* Model filtering */\n\n.model-node-highlight {\n  background-color: yellow;\n  color: black;\n  font-weight: bold;\n}\n\n.model-node-uid {\n  color: #888;\n  font-size: 0.85em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
